import React from "react";

import styles from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={styles.spinner}>
      <span></span>
    </div>
  );
};

export default Loader;
